import { del, get, post, patch } from '../libs/requestClient';
export const fetchAllSurvey = () => get('/v1/survey');
